import { all } from 'redux-saga/effects'
import signup from '../services/signup/sagas'
import signin from '../services/signin/sagas'
import crypto from '../services/crypto/sagas'
import note from '../services/note/sagas'
import notes from '../services/notes/sagas'

export default function*() {
  yield all([signup(), signin(), crypto(), note(), notes()])
}



// WEBPACK FOOTER //
// ./src/redux/saga.js